"use client";

import Image from "next/image";
import { useRouter } from "next/navigation";
import { FormEvent, useState } from "react";

export default function SplashScreenForm() {
  const router = useRouter();
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError("");
    setIsSubmitting(true);

    try {
      const response = await fetch("/api/splash-login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ password }),
      });

      if (response.ok) {
        router.push("/simulation");
        return;
      }

      setError("Incorrect password. Please try again.");
    } catch {
      setError("Unable to sign in right now. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main
      className="flex min-h-screen items-center justify-center px-6"
      style={{
        backgroundColor: "#04031F",
        backgroundImage:
          "linear-gradient(to right, #000000 0%, rgba(0, 0, 0, 0) 40%), linear-gradient(to left, #000000 0%, rgba(0, 0, 0, 0) 40%), linear-gradient(to bottom, #000000 0%, rgba(0, 0, 0, 0) 40%), linear-gradient(to top, #000000 0%, rgba(0, 0, 0, 0) 40%)",
      }}
    >
      <form onSubmit={onSubmit} className="flex w-full max-w-md flex-col items-center gap-2">
        <Image
          src="/infinily_logo.png"
          alt="Infinily"
          width={542}
          height={186}
          priority
          className="-mt-28 mb-1 h-auto w-full"
        />

        <input
          type="password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          placeholder="Enter Password"
          className="w-2/5 rounded-full border border-[#7A7A84] bg-transparent mt-14 px-4 py-1.5 text-base text-[#F1F1F1] outline-none transition placeholder:text-[#8D8D9A] focus:border-[#A0A0AD]"
          autoComplete="current-password"
          required
        />

        <button
          type="submit"
          disabled={isSubmitting}
          className="w-2/5 rounded-full border border-[#7A7A84] bg-transparent mt-2 px-4 py-1.5 text-md tracking-[0.12em] text-white transition hover:bg-white/10 hover:border-[#A0A0AD] disabled:cursor-not-allowed disabled:opacity-70"
        >
          {isSubmitting ? "Submitting..." : "Submit"}
        </button>

        <p
          className={`min-h-[1.5rem] text-sm ${error ? "text-[#E36A6A]" : "text-transparent"}`}
          aria-live="polite"
        >
          {error || "\u00A0"}
        </p>
      </form>
    </main>
  );
}
